<template>
    <div v-if="hasRole">
        <machine-detail :equipment="currentItem"></machine-detail>
    </div>
    <div v-else class="grid grid-cols-1 md:grid-cols-2 h-full bg-gray">
        <div class="h-40 md:h-full md:min-h-screen md:max-h-full overflow-hidden relative">
            <img src="../assets/machine.jpg" alt="Sharp - Be Original" class="hidden md:block w-full h-full object-cover object-left h-full" loading="lazy" />
            <img src="../assets/machine-mobile.jpg" alt="Sharp - Be Original" class="block md:hidden w-full h-full object-cover object-right" loading="lazy" />
            <div class="mobile-logo-container absolute top-8 left-8 md:hidden">
                <router-link
                        :to="{ name: 'signIn' }">
                    <img src="../assets/sharp-logo.png" alt="Sharp - Be Original" class=""/>
                </router-link>
            </div>
        </div>

        <div class="md:min-h-screen md:order-first ">
            <div class="md:w-96 page-container--home mx-auto md:mt-24 sc:mt-0 py-10 md:py-5  px-8 md:px-5">
                <div class="flex flex-col w-full h-full justify-between">
                    <div class="mb-16 hidden md:block">
                        <router-link
                                :to="{ name: 'signIn' }">
                            <img src="../assets/sharp-logo.png" alt="Sharp - Be Original"/>
                        </router-link>
                    </div>
                    <div class="mb-20">
                        <h1 class="mb-5 md:mb-10">Quick Access</h1>
                        <div class="" :class="{hidden: !loading}">
                            <loading></loading>
                        </div>
                        <div :class="{hidden: loading}" >
                            <auto-login-form :errorMessage="errorMessage"></auto-login-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import { get, transform } from 'lodash';
    import AutoLoginForm from './form/AutoLoginForm.vue';
    import MachineDetail from './MachineDetail.vue';
    import EquipmentCard from './includes/EquipmentCard.vue';
    import { parseEquipment } from '../service/parser';
    import Loading from './includes/Loading.vue';
    import Vuex from 'vuex';

    export default {
        data() {
            return {
                loading: false,
                showingInstruction: false,
                instruction: '',
                errorMessage: ''
            }
        },

        components: {
            AutoLoginForm,
            MachineDetail,
            Loading
        },

        computed: {
            ...Vuex.mapGetters('equipments', {
                currentItem: 'currentItem'
            }),

            ...Vuex.mapGetters('profile', {
                onPasscodePenalty: 'onPasscodePenalty',
                hasRole: 'hasRole',
            }),
        },

        created: function () {
            let data = this.getParams();

            if(!this.hasRole){
                if(data.war_id){
                    if(!this.onPasscodePenalty){
                        this.loading = true;
                        this.autoLogin(data).then(res => {
                            if(res.has_passcode){
                                this.setShowPopUp(true);
                            }else{
                                let equipment = parseEquipment(res);
                                this.loginEquipment(equipment);
                                this.$router.push({ path: 'autologin', query: { war_id: equipment.id, serial: equipment.serial}})
                            }
                        }).catch(() => {
                            this.errorMessage = "Invalid Data";
                        }).finally(() => {
                            this.loading = false;
                        })
                    }
                }
            }
        },


        methods: {
            ...Vuex.mapActions('equipments', {
                autoLogin: 'autoLogin',

            }),
            ...Vuex.mapMutations('layout', {
                setShowPopUp: 'setShowPopUp'
            }),

            ...Vuex.mapMutations('profile', {
                loginEquipment: 'loginEquipment',
            }),
            getParams(){
                return transform(this.$route.query, function (result, val, key) {
                    result[key.toLowerCase()] = val;
                });
            }

        }
    }
</script>
